import { z } from 'zod';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
import { PlayerColor } from '../PlayerState.ts';
const mechanicShipPlayerStateSchema = z.object({
    bankShipAmount: z.number().int().nonnegative(),
    restrictedShipPlacements: z.union([
        z.array(z.number().int().nonnegative()),
        z.null()
    ]).exactOptional(),
    hasMovedShipThisTurn: z.union([
        z.literal(true),
        z.null()
    ]).exactOptional(),
    restrictedShipMovesFrom: z.union([
        z.array(z.number().int().nonnegative()),
        z.null()
    ]).exactOptional()
}).strict();
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const mechanicShipStateSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicShipPlayerStateSchema);
export function validateMechanicShipState(data) {
    return validateState(mechanicShipStateSchema, data);
}
const mechanicShipPlayerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicShipPlayerStateSchema);
export const mechanicShipStatePartialSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicShipPlayerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
